export default __webpack_public_path__ + "static/marta_alingua-scaled-29ee333a49cb7aa49d2746d3b4b71c3f.jpg";